import React, { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";
import { SERVICES } from "../mock";

const ServiceCard = ({ service, index }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setInView(true),
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const Icon = service.icon;

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 3) * 90}ms` }}
      className={`group bg-white rounded-none overflow-hidden border border-[#efe9df] hover:shadow-[0_20px_44px_rgba(27,43,69,0.12)] hover:-translate-y-1 transition-all duration-300 fade-up ${
        inView ? "in-view" : ""
      }`}
    >
      <div className="relative h-48 overflow-hidden bg-[#f7f4ee]">
        <img
          src={service.image}
          alt={service.title}
          className={`w-full h-full ${
            service.fit === "contain" ? "object-contain p-2" : "object-cover"
          } group-hover:scale-105 transition-transform duration-500`}
        />
      </div>
      <div className="p-6 relative">
        <span className="absolute -top-7 left-6 w-14 h-14 rounded-none bg-[#c79a5b] flex items-center justify-center shadow-md">
          <Icon size={24} className="text-[#1b2b45]" />
        </span>
        <h3 className="font-heading mt-6 text-[24px] font-bold text-[#1b2b45] leading-tight">
          {service.title}
        </h3>
        <p className="mt-2 text-[14px] text-[#8a92a3] leading-relaxed">{service.desc}</p>
        <ul className="mt-4 space-y-2.5">
          {service.points.map((p) => (
            <li key={p} className="flex items-start gap-2.5">
              <Check size={16} className="text-[#c79a5b] shrink-0 mt-0.5" strokeWidth={2.5} />
              <span className="text-[13.5px] text-[#4b5568]">{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <section id="sluzby" className="py-20 md:py-28 bg-[#f7f4ee]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <span className="eyebrow-line">Co nabízíme</span>
          <h2 className="font-heading mt-5 text-[30px] sm:text-[38px] md:text-[52px] font-bold text-[#1b2b45] leading-tight">
            Služby na klíč
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-7 gap-y-12">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.title} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
